import React, { useState, Dispatch, SetStateAction, useEffect } from 'react'
import styles from '../styles/Register.module.scss'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import {
	Row,
	Col,
	OverlayTrigger,
	Popover,
	Button
} from 'react-bootstrap'

// interface Experience {
//   id: number | string,
//   jobTitle: string,
//   companyName: string,
//   occupation: number,
//   startDate: string,
//   endDate: string,
//   description: string
// }

// interface Education {
//   id: number | string,
//   schoolName: string,
//   educationOther: string,
//   fieldOfStudy: string,
//   startYear: number,
//   endYear: number,
//   grade: string,
//   description: string,
//   Enum_EducationLevel: { display: string }
// }
interface OptionalProps {
	experiences?: Array<any>,
	setExperiences?: Dispatch<SetStateAction<Array<any>>> | Dispatch<SetStateAction<[]>>,
	experienceIds?: Array<number> | [],
	setExperienceIds?: Dispatch<SetStateAction<Array<number>>> | Dispatch<SetStateAction<[]>>,
	educations?: Array<any>,
	setEducations?: Dispatch<SetStateAction<Array<any>>> | Dispatch<SetStateAction<[]>>,
	educationIds?: Array<number> | [],
	setEducationIds?: Dispatch<SetStateAction<Array<number>>> | Dispatch<SetStateAction<[]>>,
	showDeleteBtn?: boolean
}

// Work Experience
const IndividualCardBody = ({
	experience, experiences, setExperiences, experienceIds, setExperienceIds, showDeleteBtn, showDivider
}): JSX.Element => {
	// experience --> each individual ApplicantExperience row
	// experiences --> arr that holds experience(s) above
	// experienceIds --> arr that holds the id of ApplicantExperience to delete
	const [show, setShow] = useState(false)

	const [isLongText, setIsLongText] = useState(false)
	const [isExpanded, setIsExpanded] = useState(false)
	const { t } = useTranslation()

	const formatDate = (date): string => {
		if (date.includes('-') === true) {
			const arr = date.split('-')
			const MMM = moment().month(arr[1] - 1).format('MMM')
			const year: string = arr[0]

			return `${MMM} ${year}`
		} else if (date.includes('/') === true) {
			const arr = date.split('/')
			const MMM = moment().month(arr[0] - 1).format('MMM')
			const year: string = arr[1]
			return `${MMM} ${year}`
		} else return ''
	}

	const getStartEndDate = (): string => {
		const { startDate, endDate } = experience
		return `${startDate !== null ? formatDate(startDate) : ''} - ${endDate !== null ? formatDate(endDate) : 'Present'}`
	}

	const handleDelete = (id): void => {
		// Know if deleted ele is from Database
		if (typeof id === 'number') {
			const updatedArr = experienceIds.concat(id)
			setExperienceIds(updatedArr)
		}
		const filteredArr = experiences.filter(ele => ele.id !== id)
		setExperiences(filteredArr)
	}

	const popover = (
		<Popover id='popover-basic'>
			<Popover.Header as='h3'>{t('update_profile.are_you_sure_want_to_delete')}</Popover.Header>
			<Popover.Body style={{ textAlign: 'center' }}>
				<Button
					variant='danger'
					className={styles.selectItem}
					onClick={() => {
						handleDelete(experience.id)
						setShow(false)
					}}
				>
					{t('update_profile.yes')}
				</Button>
				<Button
					variant='light'
					onClick={() => setShow(false)}
				>
					{t('update_profile.no')}
				</Button>
			</Popover.Body>
		</Popover>
	)

	useEffect(() => {
		const paragraphTag = document.getElementById(`descr-${experience.id}`)
		if (paragraphTag !== null) {
			const paragraphHeight = paragraphTag.offsetHeight
			if (paragraphHeight > 96) setIsLongText(true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Row className='m-3'>
				<Col style={{ marginBottom: 0 }}>
					<p style={{ marginBottom: '2px' }}>
						<span style={{ fontWeight: 'bolder' }}>{experience.jobTitle}</span>&nbsp;{experience.companyName !== null && `at ${experience.companyName}`}
					</p>
				</Col>
				{showDeleteBtn === true && (
					<Col style={{ textAlign: 'right' }}>
						<OverlayTrigger trigger='click' placement='left' overlay={popover} show={show}>
							<Button variant='primary' onClick={() => setShow(!show)} className='text-white'>
								{t('update_profile.delete')}
							</Button>
						</OverlayTrigger>
					</Col>
				)}
				<Row>
					{experience.startDate !== null && (
						<>
							<p style={{ fontSize: '0.9rem' }} className='text-muted'>
								{
									getStartEndDate()
								}
							</p>
							<p
								id={`descr-${experience.id}`}
								style={{
									whiteSpace: 'pre-wrap', marginBottom: 0,
									// 2 Conditions
									...((isLongText === true && isExpanded === false) && {
										maxHeight: '6em', overflow: 'hidden', textOverflow: 'ellipsis'
									})
								}}
							>
								{experience.description}
							</p>
							{
								(isLongText === true && isExpanded === true) && <Button variant='link' onClick={() => setIsExpanded(false)} style={{ float: 'right', textDecoration: 'underline', color: '#222529' }}>{t('update_profile.show_less')}</Button>
							}
							{
								(isLongText === true && isExpanded === false) && <Button variant='link' onClick={() => setIsExpanded(true)} style={{ float: 'right', textDecoration: 'underline', color: '#222529' }}>{t('update_profile.show_more')}</Button>
							}
						</>
					)}
				</Row>
			</Row>
			<Row className='mx-4'>
				{
					showDivider && <hr className={styles.divider} />
				}
			</Row>
		</>
	)
}

const IndividualEducationCardBody = ({
	education, educations, setEducations, educationIds, setEducationIds, showDeleteBtn, showDivider
}): JSX.Element => {
	const [show, setShow] = useState(false)

	const { t } = useTranslation()
	const [isLongText, setIsLongText] = useState(false)
	const [isExpanded, setIsExpanded] = useState(false)

	const returnEducationLevel = (): string => {
		// const educationEnums = ['ALEVEL', 'DEGREE', 'DIPLOMA', 'HIGHERNITEC', 'NITEC', 'NLEVEL', 'OLEVEL', 'PSLE', 'SEC']
		if (typeof education.id !== 'number') {
			if (showDeleteBtn === true) return education.educationDisplay
			else if (education.Enum_EducationLevel.display === 'Others') return education.educationOther
			else return education.Enum_EducationLevel.display
		} else {
			if (education.Enum_EducationLevel.display === 'Others') return education.educationOther
			else return education.Enum_EducationLevel.display
		}
	}

	const handleDelete = (id): void => {
		// Know if deleted ele is from Database
		if (typeof id === 'number') {
			const updatedArr = educationIds.concat(id)
			setEducationIds(updatedArr)
		}
		const filteredArr = educations.filter(ele => ele.id !== id)
		setEducations(filteredArr)
	}

	const popover = (
		<Popover id='popover-basic'>
			<Popover.Header as='h3'>{t('update_profile.are_you_sure_want_to_delete')}</Popover.Header>
			<Popover.Body style={{ textAlign: 'center' }}>
				<Button
					variant='danger'
					className={styles.selectItem}
					onClick={() => {
						handleDelete(education.id)
						setShow(false)
					}}
				>
					{t('update_profile.yes')}
				</Button>
				<Button
					variant='light'
					onClick={() => setShow(false)}
				>
					{t('update_profile.no')}
				</Button>
			</Popover.Body>
		</Popover>
	)

	useEffect(() => {
		const paragraphTag = document.getElementById(`ed-${education.id}`)
		if (paragraphTag !== null) {
			const paragraphHeight = paragraphTag.offsetHeight
			if (paragraphHeight > 96) setIsLongText(true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Row className='m-3'>
				<Col style={{ marginBottom: 0 }}>
					<p style={{ marginBottom: '2px' }}>
						<span style={{ fontWeight: 'bolder' }}>{education.schoolName}</span>
					</p>
				</Col>
				{showDeleteBtn === true && (
					<Col style={{ textAlign: 'right' }}>
						<OverlayTrigger trigger='click' placement='left' overlay={popover} show={show}>
							<Button variant='primary' onClick={() => setShow(!show)} className='text-white'>
								{t('update_profile.delete')}
							</Button>
						</OverlayTrigger>
					</Col>
				)}
				<Row>
					<p style={{ marginBottom: 0, fontSize: '1.05rem' }}>
						{returnEducationLevel()}, {education.fieldOfStudy}
						{education.grade > 0 && ` , ${education.grade}`}
					</p>
					<p style={{ fontSize: '0.9rem' }} className='text-muted'>
						{education.startYear} - {education.endYear}
					</p>
					<p
						id={`ed-${education.id}`}
						style={{
							whiteSpace: 'pre-wrap', marginBottom: 0,
							// 2 Conditions
							...((isLongText === true && isExpanded === false) && {
								maxHeight: '6em', overflow: 'hidden', textOverflow: 'ellipsis'
							})
						}}
					>
						{education.description}
					</p>
					{(isLongText === true && isExpanded === true) && <Button variant='link' onClick={() => setIsExpanded(false)} style={{ float: 'right', textDecoration: 'underline', color: '#222529' }}>{t('update_profile.show_less')}</Button>}
					{(isLongText === true && isExpanded === false) && <Button variant='link' onClick={() => setIsExpanded(true)} style={{ float: 'right', textDecoration: 'underline', color: '#222529' }}>{t('update_profile.show_more')}</Button>}
				</Row>
			</Row>
			<Row className='mx-4'>
				{
					showDivider && <hr className={styles.divider} />
				}
			</Row>
		</>
	)
}

const CardBodyComponent: React.FunctionComponent<OptionalProps> = ({
	experiences, setExperiences, experienceIds, setExperienceIds,
	educations, setEducations, educationIds, setEducationIds,
	showDeleteBtn
}) => {
	// const experiencesArr: () = experiences
	return (
		<>
			{experiences !== undefined && (experiences as Array<any>).map((experience, index) => (
				<IndividualCardBody
					key={index}
					experience={experience}
					experiences={experiences}
					setExperiences={setExperiences}
					experienceIds={experienceIds}
					setExperienceIds={setExperienceIds}
					showDeleteBtn={showDeleteBtn === false ? false : true}
					showDivider={index !== Object.keys(experiences).length - 1 ? true : false}
				/>
			))}
			{educations !== undefined && (educations as Array<any>).map((education, index) => (
				<IndividualEducationCardBody
					key={index}
					education={education}
					educations={educations}
					setEducations={setEducations}
					educationIds={educationIds}
					setEducationIds={setEducationIds}
					showDeleteBtn={showDeleteBtn === false ? false : true}
					showDivider={index !== Object.keys(educations).length - 1 ? true : false}
				/>
			))}
		</>
	)
}

export default CardBodyComponent
